<template>
  <div>
    <div>
      <el-dialog title="查看单据" center :visible.sync="CKDJVisible" width='55%' :close-on-click-modal="false" :before-close="CKQuXiao">
        <div class="demo-image__preview" v-if="!lookFlag">
          <div>
            <p>随车小票</p>
             <span v-for="(item, index) in imgObj.receipt_on_vehicle" :key="item.imgId">
              <el-image
              :preview-src-list="getSrcList(index,imgObj.receipt_on_vehicle)"
              fit="cover"
              :src="item.imgUrl"
              style="width:200px;height:200px;margin:0 20px 20px;">
              </el-image>
            </span>
          </div>
          <div>
            <p>质检单</p>
            <span v-for="(item, index) in imgObj.quality_inspection_sheet" :key="item.imgId">
              <el-image
              :preview-src-list="getSrcList(index,imgObj.quality_inspection_sheet)"
              fit="cover"
              :src="item.imgUrl"
              style="width:200px;height:200px;margin:0 20px 20px;">
              </el-image>
            </span>
          </div>
        </div>
        <span v-if="lookFlag">暂无图片</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="CKQuXiao">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  billList
} from '@/api/wms-access'
export default {
  name: 'djDialog',
  data () {
    return {
      imgListTop: [],
      imgListDown: [],
      lookFlag: true,
      imgObj: {}
    }
  },
  props: {
    CKDJVisible: {
      type: Boolean,
      default: false
    },
    instockId: {
      type: String,
      default: ''
    }
  },
  methods: {
    // 点击凭证放大
    getSrcList (index, arr) {
      const list = arr.map(item => item.imgUrl)
      return list.slice(index).concat(list.slice(0, index))
    },
    CKQuXiao () {
      this.$emit('update:CKDJVisible', false)
    }
  },
  mounted () {
    billList(this.instockId)
      .then(res => {
        if (JSON.stringify(res) != '{}') {
          this.lookFlag = false
          this.imgObj = res
        } else {
          this.lookFlag = true
        }
      })
      .catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
  }
}
</script>

<style>

</style>
